import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Plus, X } from "lucide-react";
import { cn } from "@/lib/utils";

export default function ChecklistSection({ checklist = [], onChange }) {
  const [newItem, setNewItem] = useState("");

  const addItem = () => {
    if (!newItem.trim()) return;
    const updated = [...checklist, {
      id: Date.now().toString(),
      text: newItem,
      completed: false
    }];
    onChange(updated);
    setNewItem("");
  };

  const toggleItem = (id) => {
    const updated = checklist.map(item =>
      item.id === id ? { ...item, completed: !item.completed } : item
    );
    onChange(updated);
  };

  const removeItem = (id) => {
    onChange(checklist.filter(item => item.id !== id));
  };

  const completedCount = checklist.filter(item => item.completed).length;

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium text-slate-700">Sjekkliste</label>
        {checklist.length > 0 && (
          <span className="text-xs text-slate-500">
            {completedCount}/{checklist.length} fullført
          </span>
        )}
      </div>

      {checklist.length > 0 && (
        <div className="space-y-2 p-3 bg-slate-50 rounded-lg">
          {checklist.map((item) => (
            <div key={item.id} className="flex items-center gap-2 group">
              <Checkbox
                checked={item.completed}
                onCheckedChange={() => toggleItem(item.id)}
              />
              <span className={cn(
                "flex-1 text-sm",
                item.completed && "line-through text-slate-400"
              )}>
                {item.text}
              </span>
              <button
                type="button"
                onClick={() => removeItem(item.id)}
                className="opacity-0 group-hover:opacity-100 p-1 hover:bg-slate-200 rounded transition-opacity"
              >
                <X className="w-3 h-3 text-slate-500" />
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="flex gap-2">
        <Input
          value={newItem}
          onChange={(e) => setNewItem(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addItem())}
          placeholder="Legg til sjekklistepunkt..."
          className="h-9 text-sm"
        />
        <Button type="button" size="sm" onClick={addItem} variant="outline">
          <Plus className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}